/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { TranslateModule } from '@ngx-translate/core';
import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-edc-info-modal-tabs',
	standalone: true,
	imports: [ TranslateModule ],
	templateUrl: './edc-info-modal-tabs.component.html',
	styleUrl: './edc-info-modal-tabs.component.scss'
})

export class EdcInfoModalTabsComponent {

	@Input({ required: true }) tabGroupId!: string;

}